export default __webpack_public_path__ + "static/media/PaintingPenArtSchool.f0ed4399.jpg";